import { UserCoreBase } from "./user.core.base"


export class UserCore extends UserCoreBase {

}